import useAuth from '@sdk/authentication/useAuth';
import type { Shift } from '@sdk/automatedBreaks/types/Shift';
import { BreakCategory } from '@sdk/settings/types';
import { getAutomatedBreaksSettingsForShift } from '@sdk/automatedBreaks/utils';

import { useAutomatedBreaksSettings } from '@web/settings/components/schedule/Breaks/breaks.hooks';
import getScheduledBreaksSummary from '@web/timeClock/utils/getScheduledBreaksSummary';
import getDisplayLabel from '@web/timeClock/utils/getDisplayLabel';
import useIsAutomatedBreaksFeatureFlagEnabled from '@web/automatedBreaks/hooks/useIsAutomatedBreaksFeatureFlagEnabled';

export const useScheduledRowContent = (shift: Shift) => {
  const automatedBreaksFeatureFlag = useIsAutomatedBreaksFeatureFlagEnabled();
  const { automatedBreaks } = useAutomatedBreaksSettings();
  const { currentUser } = useAuth();
  const { shiftBreakType } = currentUser.orgSettings;
  const isStandardBreakPaid = shiftBreakType === BreakCategory.paid;

  const automatedBreaksSettings = getAutomatedBreaksSettingsForShift(shift, automatedBreaks);

  const displayLabel = getDisplayLabel({
    shift,
    usTimeFormat: currentUser.settings.usTimeFormat,
    automatedBreaksSettings,
    automatedBreaksFeatureFlag,
    isStandardBreakPaid,
  });

  const displaySummary = getScheduledBreaksSummary({
    shift,
    automatedBreaksSettings,
    automatedBreaksFeatureFlag,
  });

  return {
    displayLabel,
    displaySummary,
  };
};
